import { Component, Input } from '@angular/core';

import { valueAccessorFactory } from '../../helpers';
import { BaseInputDirective } from '../base-input.directive';
import { formControlFactory } from '../form-control.provider';

@Component({
  selector: 'pcs-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss'],
  providers: [
    valueAccessorFactory(RadioButtonComponent),
    formControlFactory(RadioButtonComponent)
  ]
})
export class RadioButtonComponent extends BaseInputDirective {
  @Input() value: any;

  checked = false;

  writeValue(value: any): void {
    this.checked = value === this.value;
  }

  onChange() {
    this.select();
  }

  onBlur(event) {
    this.propagateTouched(event);
  }

  private select() {
    if (!this.disabled) {
      this.checked = true;
      this.propagateChange(this.value);
    }
  }

}
